import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'system',
    useSystemColorMode: true,
  },
  colors: {
    // Paleta principal de la marca
    brand: {
      50: '#E6F0FF',
      100: '#B8D4FF',
      200: '#8AB9FF',
      300: '#5C9DFF',
      400: '#2E82FF',
      500: '#0066FF', // Color principal
      600: '#0056DB',
      700: '#0041A3',
      800: '#002F75',
      900: '#001D47',
      950: '#000A1A',
    },
    // Sombras (para modo oscuro)
    dark: {
      50: '#0056DB',
      100: '#104EC5',
      200: '#1746AF',
      300: '#1B3F9A',
      400: '#1C3786',
      500: '#1D3071',
      600: '#1C295E',
      700: '#19224B',
      800: '#171B39',
      900: '#131528',
      950: '#0C0C18',
    },
    // Tintes (variaciones claras)
    tint: {
      50: '#EEEEFC',
      100: '#DEDEFA',
      200: '#CDCDF7',
      300: '#BBBDF4',
      400: '#AAAEF1',
      500: '#989EED',
      600: '#858FEA',
      700: '#7080E6',
      800: '#5972E3',
      900: '#3D64DF',
      950: '#0056DB',
    },
    // Tonos (variaciones con gris)
    tone: {
      50: '#0056DB',
      100: '#2E5AD2',
      200: '#425EC9',
      300: '#4F62C0',
      400: '#5A66B7',
      500: '#636AAE',
      600: '#6A6EA5',
      700: '#71739C',
      800: '#777793',
      900: '#7C7C89',
      950: '#808080',
    },
  },
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'dark.950' : 'tint.50',
        color: props.colorMode === 'dark' ? 'gray.100' : 'gray.800',
        scrollBehavior: 'smooth',
      },
      // Mejoras para secciones en modo oscuro
      'section': {
        bg: props.colorMode === 'dark' ? 'transparent' : 'transparent',
        scrollMarginTop: '127px',
      },
    }),
  },
  components: {
    Button: {
      variants: {
        primary: {
          bg: 'brand.500',
          color: 'white',
          fontWeight: '600',
          borderRadius: 'full',
          _hover: {
            bg: 'brand.400',
          },
        },
        ghost: (props) => ({
          bg: 'transparent',
          color: props.colorMode === 'dark' ? 'gray.100' : 'gray.700',
          border: '1px solid',
          borderColor: props.colorMode === 'dark' ? 'whiteAlpha.400' : 'gray.300',
          borderRadius: 'full',
          _hover: {
            bg: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.100',
          },
        }),
      },
    },
    Container: {
      baseStyle: {
        maxW: '1120px',
        px: { base: 4, md: 6 },
      },
    },
    Text: {
      baseStyle: {
        textAlign: 'left',
      },
    },
  },
});

export default theme;
